import request from '@/utils/request'

// 转帐所需能量
export function energyInfo() {
  return request({
    url: '/energy/info',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/energy.js